import Axios from "./axios";

const resource = "promos";

export default {
  get() {
		return Axios.get(`${resource}`);
	},
	check(c) {
		return Axios.post(`${resource}/check/code`, { code: c});
	},
}